import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { partnersApi } from '@src/features/users/services/partners-api';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipPartnerValue = ({ id }: ChipValueRendererProps) => {
  const { data: partner } = partnersApi.useFetchOne({ id });

  return (
    <>
      <Avatar className='size-3'>
        <AvatarImage src={partner?.avatar} />
        <AvatarFallback colorId={partner?.id as number}>
          {partner?.company_name?.[0]}
        </AvatarFallback>
      </Avatar>
      {partner?.company_name}
    </>
  );
};
